import React from "react";
import ReactDatePicker from "react-datepicker";
import { useController } from "react-hook-form";
import { enUS } from "date-fns/esm/locale";
import { useTranslation } from "react-i18next";

const DATE_PICKER_TYPE = {
	DATE: "date",
	MONTH: "month",
	QUARTER: "quarter",
	YEAR: "year",
};

const DATE_FORMAT = {
	[DATE_PICKER_TYPE.DATE]: "yyyy. MM. dd.",
	[DATE_PICKER_TYPE.MONTH]: "yyyy. MM",
	[DATE_PICKER_TYPE.QUARTER]: "yyyy년 q분기",
	[DATE_PICKER_TYPE.YEAR]: "yyyy",
};

const DatePicker = (props) => {
	const {
		control,
		name,
		validation,
		defaultValue,
		datePickerName,
		required,
		month,
		year,
		quarter,
		onChange,
		readonly,
		placeholderText,
		minDate,
		maxDate,
	} = props;

	const { t } = useTranslation();

	const type = year
		? DATE_PICKER_TYPE.YEAR
		: quarter
		? DATE_PICKER_TYPE.QUARTER
		: month
		? DATE_PICKER_TYPE.MONTH
		: DATE_PICKER_TYPE.DATE;

	const { field } = useController({
		control,
		name,
		rules: {
			required: required && t("common.components.DatePicker.requiredInput"),
			...validation,
		},
		defaultValue: defaultValue ? defaultValue : new Date(),
	});

	return (
		<ReactDatePicker
			onChange={(date) => {
				field.onChange(date);
				onChange && onChange(date);
			}}
			selected={new Date(field.value)}
			dateFormat={DATE_FORMAT[type]}
			className={"c__input c__datePicker " + (datePickerName ? datePickerName : "")}
			showYearDropdown
			showQuarterYearPicker={type === "quarter"}
			showMonthYearPicker={type === "month"}
			showFullMonthYearPicker={type === "date"}
			useShortMonthInDropdown
			dateFormatCalendar=" "
			showMonthDropdown
			dropdownMode="select"
			locale={enUS}
			readOnly={readonly}
			placeholderText={placeholderText}
			minDate={minDate ? minDate : null}
			maxDate={maxDate ? maxDate : null}
		/>
	);
};

export default DatePicker;
